import {type AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {type PerksListBody, ViewPopupBecomeMember} from './ViewPopupBecomeMember.ts'
import {LobbyImage} from '@colonist/types'

export class ViewPopupBecomeMemberGameplay extends ViewPopupBecomeMember {
    constructor(checkAction: () => void, analyticEventValue?: AnalyticEventValue, xAction: () => void = () => undefined, showXButton: boolean = false) {
        super(checkAction, analyticEventValue, xAction, showXButton)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getBenefits(): PerksListBody[] {
        return [
            {
                image: LobbyImage.GameModeCnKSeafarers,
                title: {key: 'strings:popups.becomeAMember.perks.allExpansions.title'},
                description: {key: 'strings:popups.becomeAMember.perks.allExpansions.description'},
            },
            {
                image: LobbyImage.MapUSAPreview,
                title: {key: 'strings:popups.becomeAMember.perks.allMaps.title'},
                description: {key: 'strings:popups.becomeAMember.perks.allMaps.description'},
            },
            {
                image: LobbyImage.GameModeCnK,
                title: {key: 'strings:popups.becomeAMember.perks.rankedCK.title'},
                description: {key: 'strings:popups.becomeAMember.perks.rankedCK.description'},
            },
        ]
    }
}
